import * as React from 'react';

export const header = {
  heading: 'How Do We Use Information?'
};
export const richText1 = {
  id: 'InformationUsage',
  html:
    '                <p>Here are some examples of how we use the information we collect:</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>To respond to you and provide you with goods and services you request.</p>\n'
    + '                <ul>\n'
    + '                  <li>Fulfilling orders, ensuring proper delivery, or providing services \n'
    + '                      (such as delivering an electronic copy of your receipt) </li>\n'
    + '                  <li>Administering your participation in a contest, sweepstakes, or \n'
    + '                      other promotion or sending you prizes you might have won</li>\n'
    + '                  <li>Registering you for a particular website, loyalty program, or \n'
    + '                      extended warranty service, or providing you with information regarding \n'
    + '                      such programs or services </li>\n'
    + '                  <li>Processing a return (to learn more about our Returns Policy, \n'
    + '                      <a href = "https://www.homedepot.com/c/Return_Policy"> click here </a>) </li>\n'
    + '                  <li>Responding to a product or service review </li>  \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>To improve our business, products, and services. </p>\n'
    + '                <ul> \n'
    + '                  <li>Improving our websites, mobile applications, and applications for other connected devices </li>\n'
    + '                  <li>Identifying ways to make our products and services better </li>\n'
    + '                  <li>Improving store layouts</li>\n'
    + '                  <li>Developing new ways to purchase and browse our products and services</li>\n'
    + '                  <li>Personalizing the content on our digital services (e.g., websites, mobile \n'
    + '                  applications, and connected device applications) so you have a consistent experience </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>To identify and assess website and device application trends and customer interests. </p>\n'
    + '                <ul> \n'
    + '                  <li>Recommending products and services that may interest you </li> \n'
    + '                  <li>Identifying the devices you use to interact with us so that we can provide you with a consistent experience </li>\n'
    + '                  <li>Identifying your interests based on your interactions with us and information we have received from \n'
    + '                      third parties or publicly available sources </li>\n'
    + '                  <li>Updating our product inventories to meet projected demand </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                 <p> For security and asset protection purposes. </p> \n'
    + '                <ul> \n'
    + '                  <li>In-store, parking lot, and facility cameras track store traffic, stock, ' +
    'and vehicles (in jurisdictions where permitted)</li> \n'
    + '                  <li>Mitigating credit losses </li>\n'
    + '                  <li>Confirming the identity of our customers who rent trucks or certain types of tools or equipment </li> \n'
    + '                  <li>Retrieving unreturned tools or other equipment </li>\n'
    + '                  <li>Processing and tracking returns </li>\n'
    + '                  <li>Detecting and preventing fraud and malicious activities on our digital offerings and in your accounts </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>For our marketing. </p>\n'
    + '                <ul> \n'
    + '                  <li>Sending you communications about special The Home Depot promotions or offers via regular mail, email,\n'
    + '                      phone, or other electronic channels, including ads on social media platforms </li> \n'
    + '                  <li>Sending you newsletters and other information you have requested </li>\n'
    + '                  <li>Informing you of new in-store or digital products and service offerings </li> \n'
    + '                  <li>Passing along information about offers from our Affiliates and other companies we think you might find interesting, such as extended warranties on products\n </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>You can update certain marketing communications preferences by following the instructions in the \n'
    + '                   <a href="#MarketingPreferences">Manage Marketing Preferences</a> section below.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>To provide you with ads and other communications that align with your interests, we may use \n'
    + '                   information collected across different online services and collected from the various devices \n'
    + '                   you use. For example, if you view a product on our website or mobile application, we may arrange \n'
    + '                   for you to see ads for that product or similar products on our websites and applications, or third party websites and applications.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p> To communicate with you about your account or our relationship. </p>'
    + '                <ul> \n'
    + '                  <li>Notifying you about changes to this Privacy and Security Statement, the Terms of Use of our websites \n'
    + '                      or device applications, or changes to any of our programs in which you might be enrolled </li> \n'
    + '                  <li>Updating you regarding shipping, product availability, product recalls, warranty information, or rebates </li>\n'
    + '                  <li>Sending you other transactional or relationship communications</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> For employment purposes.  </p>'
    + '                <ul> \n'
    + '                  <li>Processing and responding to your application for or inquiry regarding employment with us.</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> For social media engagement. </p>'
    + '                <ul> \n'
    + '                  <li>When you engage with our content on or through social networking websites, plug-ins and applications, \n'
    + '                       you may allow us to have access to certain social media account information (e.g., name, username, \n'
    + '                       email address, gender) as determined by the settings of the social media platforms to \n'
    + '                       deliver the content or as part of the operation of the website, plug-in or application </li> \n'
    + '                  <li>Such social media platforms may collect information about your use of our services and may \n'
    + '                      notify other users of the platform about your activities on our websites and device applications  </li>\n'
    + '                  <li>These social media platforms may also use cookies or other technologies to provide services or \n'
    + '                      track your online activities over time and across multiple websites and device applications. \n'
    + '                      Your interactions with social media features are governed by the respective privacy policies\n'
    + '                      of the social media platforms</li> \n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p> For other uses we may disclose to you.</p>\n'
    + '                <ul> \n'
    + '                  <li>We may also use information for purposes disclosed to you at the point of collection, as authorized \n'
    + '                  by you, or as otherwise permitted or required by law.</li> \n'
    + '                 </ul>\n'

};
